import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  PaymentPlanSharedComponent: {
    width: "100%",
    padding: "24px",
    gap: "16px",
    display: "flex",
    flexDirection: "column",
  },
  containerHeader: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  rowLayout: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    backgroundColor: theme.palette.background.secondary_hover,
    borderRadius: "12px",
    padding: "5px 20px",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
    },
  },
  containerBody: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  containerLeftSide: {
    display: "flex",
    flexDirection: "row",
    gap: "16px",
  },
}));
